import { APP_INITIALIZER, Provider } from '@angular/core';
import { patchPrimeDynamicDialog, patchPrimeDialog } from './app.utils';

export const PATCH_DYNAMIC_DIALOG_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: patchPrimeDynamicDialog
};

export const PATCH_DIALOG_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: patchPrimeDialog
};

export const PRIME_PATCH_PROVIDERS = [PATCH_DYNAMIC_DIALOG_PROVIDER, PATCH_DIALOG_PROVIDER];
